class Sound {

  // Constructor
  constructor() {
    this.API_ENDPOINT = "https://www.sria.co.jp/apps/happynewyear2018/php/api";
    createjs.Sound.registerSound("assets/sounds/se/fly.mp3", "fly");
    createjs.Sound.registerSound("assets/sounds/se/button.mp3", "button");
  }

  /**
   * 上昇音再生
   */
  playFly() {
    createjs.Sound.play('fly');
  }

  /**
   * ボタン音再生
   */
  playButton() {
    createjs.Sound.play('button');
  }
}

module.exports = Sound;



// WEBPACK FOOTER //
// ./app/src/js/modules/sound.js